@if (isAuthenticated) {
  <mat-nav-list class="d-flex flex-column flex-grow-1">
    <!-- Root List Items -->
    @if (headerLoggedInSettings && currentNavList === NavLists.profile) {
      @if (filteredProfileLinks?.length && profileLinksLoaded) {
        <a mat-list-item href="javascript:void(0)" class="link-primary-dark" (click)="currentNavList = NavLists.root" gtmClick="">
          <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
        </a>
        @for (childItem of filteredProfileLinks; track childItem) {
          <a mat-list-item href="javascript:void(0)" [gtmClick]="childItem.Caption" (click)="this.profileButtonClick(childItem)">
            {{ childItem.Caption }}
            <mat-divider></mat-divider>
          </a>
        }
      }
    }
    @if (headerLoggedInSettings && currentNavList === NavLists.claims) {
      @if (defaultClaimsLinks?.length) {
        <a mat-list-item href="javascript:void(0)" class="link-primary-dark" (click)="currentNavList = NavLists.root" gtmClick="">
          <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
        </a>
        @for (childItem of defaultClaimsLinks; track childItem) {
          <a mat-list-item href="javascript:void(0)" [gtmClick]="childItem.Caption" (click)="this.claimsButtonClick(childItem)">
            {{ childItem.Caption }}
            <mat-divider></mat-divider>
          </a>
        }
      }
    }
    @if (headerLoggedInSettings && currentNavList === NavLists.coverage) {
      @if (defaultCoverageLinks?.length && defaultCoverageLinksLoaded) {
        <a mat-list-item href="javascript:void(0)" class="link-primary-dark" (click)="currentNavList = NavLists.root" gtmClick="">
          <adp-label labelKey="Global_Header_BackToMainMenu"></adp-label>
        </a>
        @for (childItem of defaultCoverageLinks; track childItem) {
          <a mat-list-item href="javascript:void(0)" [gtmClick]="childItem.Caption" (click)="this.coverageButtonClick(childItem)">
            {{ childItem.Caption }}
            <mat-divider></mat-divider>
          </a>
        }
      }
    }
    @if (headerLoggedInSettings && currentNavList === NavLists.root) {
      @for (item of headerLoggedInSettings; track item.Order) {
        <!-- Regular Menu Items -->
        @if (item.LinkUrl !== 'action_profile' && !item.LinkUrl.endsWith('action_claims_support') && !item.LinkUrl.endsWith('action_coverage')) {
          @if (this.checkRouteAvailability(item.LinkUrl)) {
            @if (item.LinkUrl === '/service-request') {
              @if (!serviceRequestVisibility.isHidden()) {
                <div class="service-request-button-container">
                  <button class="mat-button-style request-service-button" mat-flat-button color="accent" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl" (click)="onClickServiceRequest()">
                    <span class="utility-button-l">
                      {{ item.Caption }}
                    </span>
                  </button>
                </div>
              }
            } @else {
              <a mat-list-item [routerLink]="item.LinkUrl" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl" (click)="sidenavRef.toggle()" routerLinkActive="active">
                {{ item.Caption }}
              </a>
              <mat-divider></mat-divider>
            }
          }
        } @else {
          @if (item.LinkUrl === 'action_profile') {
            @if (chooseLanguage) {
              <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{ chooseLanguage }}</a>
            }
            <span class="flex-grow-1"></span>
            <a
              mat-list-item
              href="javascript:void(0)"
              sf-aria-label="Global_Sidenav_Profile_Aria_Label"
              routerLinkActive="active"
              (click)="currentNavList = NavLists.profile"
              style="height: 120px; background-image: url(/assets/images/profile-bubble.svg); background-repeat: no-repeat; background-color: #f0f6fc">
              <div class="avatar-container d-flex flex-grow-1 justify-content-center align-items-center">
                <span style="margin-right: 6px">
                  @if (isUserIconAvatar()) {
                    <pgh-avatar [showUserIcon]="true" size="36"></pgh-avatar>
                  } @else {
                    <pgh-avatar name="{{ fullName }}" color="{{ userAvatarColor }}" size="36"></pgh-avatar>
                  }
                </span>
                <!--<span class="circle">
                <img [src]="userAvatarUrl || './assets/images/avatars/desktop.png'"
                alt="generic avatar" /></span>-->
                <!-- <mat-icon class="primary-account-icon" svgIcon="primary-account"></mat-icon> -->
                @if (!isUserIconAvatar()) {
                  <span>{{ userGivenName }}</span>
                }
                <span class="flex-grow-1"></span>
                <mat-divider [vertical]="true" style="position: static; height: 80px"></mat-divider>
                <mat-icon>chevron_right</mat-icon>
              </div>
            </a>
          } @else {
            @if (item.LinkUrl === 'action_claims_support') {
              <a mat-list-item routerLinkActive="active" href="javascript:void(0);" (click)="currentNavList = NavLists.claims" [gtmClick]="item.Caption">
                {{ item.Caption }}
              </a>
              <mat-divider></mat-divider>
            } @else {
              <ng-container>
                <a mat-list-item routerLinkActive="active" href="javascript:void(0);" (click)="currentNavList = NavLists.coverage" [gtmClick]="item.Caption">
                  {{ item.Caption }}
                </a>
                <mat-divider></mat-divider>
              </ng-container>
            }
          }
        }
        <!-- Profile Menu Item -->
      }
    }
    <!-- Profile List Items -->
  </mat-nav-list>
}
